// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nEjc","question":"styles_question__2THb1","description":"styles_description__3i4C1"};